import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function userloginReducer(
  state = initialState.userLogin,
  action
) {
  switch (action.type) {
    case types.LOADED_USER_LOGIN_SUCCESS:
      return action.userLogin;
    default:
      return state;
  }
}
